module.exports = __webpack_public_path__ + "static/media/screwhead.f87dd843.svg";